import React, { Component } from 'react';
import SlateTextInput from '../../Shared/SlateTextInput';
import AuthButton from '../../../containers/Forms/AuthButton';
import tryMe from '../../../helpers/tryMe';

export default class FormVerficationPhoneEmail extends Component {
  UNSAFE_componentWillMount() {
    this.props.actions.setFormState({
      emailOrPhone: '',
      smsOrCall: 'sms',
      dataErrors: {
        emailOrPhone: '',
        smsOrCall: '',
      },
    });
  }

  render() {
    const { actions, state, t, formError } = this.props;
    const dataErrors = tryMe(state.dataErrors);

    return (
      <form onKeyPress={actions.handleKeyPress}>
        <div style={{ marginBottom: 16 }}>
          <SlateTextInput
            name="emailOrPhone"
            type="text"
            label={t('resetPassword:emailOrPhone')}
            value={tryMe(state).emailOrPhone || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            autoComplete="email"
            error={dataErrors.emailOrPhone}
            fullWidth
          />
        </div>
        <div className="btn-verification">
          <AuthButton
            onClick={actions.handleSubmit}
            entityName={state.entityName}
          >
            {t('resetPassword:sendVerificationCode')}
          </AuthButton>
        </div>
        <div className="btn-verification-sm">
          <AuthButton
            onClick={actions.handleSubmit}
            entityName={state.entityName}
          >
            {t('resetPassword:sendCode')}
          </AuthButton>
        </div>
        {formError && (
          <div className="auth-form-error">
            {formError}
          </div>
        )}
      </form>
    );
  }
}
